import { render, staticRenderFns } from "./AddComenziDeb.vue?vue&type=template&id=1d7ad17c&scoped=true"
import script from "./AddComenziDeb.vue?vue&type=script&lang=js"
export * from "./AddComenziDeb.vue?vue&type=script&lang=js"
import style0 from "./AddComenziDeb.vue?vue&type=style&index=0&id=1d7ad17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7ad17c",
  null
  
)

export default component.exports